import React from 'react';
import {
    Row,
    Col,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Header = ({ title, rightElement }) => {
    const { t } = useTranslation()

    return (
        < >
            <Row style={{ flexWrap: "nowrap", alignItems: "center", top: 0, zIndex: 6 }} className={"p-4 mx-0 position-sticky bg-white"}>
                <Col style={{ flex: 1 }} className='p-0'>
                    <h2 className={"mb-0"}>{t(title)}</h2>
                </Col>
                <Col className='p-0' style={{ flex: "unset", width: "unset" }}>
                    {rightElement}
                </Col>
            </Row>
        </>
    );
};

export default Header;
